import React, { useContext } from "react";
import {
  faAddressBook,
  faAddressCard,
  faBuildingUser,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import { GrupoNav, ItemNav } from "./ItemNav";

const Nomina = ({ drawerIsOpen }) => {
  let rout = getRuta();
  const { access } = useContext(DataContext);

  return (
    <GrupoNav
      icono={<FontAwesomeIcon icon={faBuildingUser} fixedWidth />}
      texto="RRHH"
      drawerIsOpen={drawerIsOpen}
    >
      {isAccess(access, "NOMINA VER") ? (
        <>
          <ItemNav
            to={`${rout}/nomina`}
            icono={<FontAwesomeIcon icon={faAddressCard} fixedWidth />}
            texto="Nómina"
            drawerIsOpen={drawerIsOpen}
          />

          <ItemNav
            to={`${rout}/employees`}
            icono={<FontAwesomeIcon icon={faAddressBook} fixedWidth />}
            texto="Empleados"
            drawerIsOpen={drawerIsOpen}
          />

          <ItemNav
            to={`${rout}/puesto`}
            icono={<FontAwesomeIcon icon={faIdBadge} fixedWidth />}
            texto="Puestos"
            drawerIsOpen={drawerIsOpen}
          />
        </>
      ) : (
        <></>
      )}
    </GrupoNav>
  );
};

export default Nomina;
